import { useLazyQuery } from "@apollo/client";
import { EXPORT_ORDER_CREDIT } from "components/gql/gql_queries_export";

import { logGQLError } from "data/functions";

export function GetOrderCreditQuery() {
  const queryName = "GetOrderCredit";

  const [refetch, variables] = useLazyQuery(EXPORT_ORDER_CREDIT, {
    fetchPolicy: "no-cache",

    onError: (e) => {
      logGQLError(queryName, e);
    },
  });
  return [refetch, variables];
}
